import { render, staticRenderFns } from "./AllLocksView.vue?vue&type=template&id=4994f2ba&scoped=true&"
import script from "./AllLocksView.vue?vue&type=script&lang=js&"
export * from "./AllLocksView.vue?vue&type=script&lang=js&"
import style0 from "./AllLocksView.vue?vue&type=style&index=0&id=4994f2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994f2ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
